<template>
  <HTML v-loading="loading" />
</template>

<script>
import HTML from './html.vue'
import './pdf/viewer.css'
import './pdf/pdf_viewer.css'
import './pdf/text_layer_builder.css'
import './pdf/annotation_layer_builder.css'
import { PDFViewerApplicationOptions, webViewerLoad } from './pdf/viewer.js'
export default {
  name: 'PDFRender',
  components: {
    HTML,
  },
  props: {
    url: String,
    title: String,
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    renderPDF(url) {
      try {
        PDFViewerApplicationOptions.set('defaultUrl', url)
        PDFViewerApplicationOptions.set('documentTitleOverride', this.title || '')
        return webViewerLoad()
      } catch (e) {
        console.warn(e)
      }
    },
    async init() {
      try {
        if (this.url) {
          this.loading = true
          await this.renderPDF(this.url)
          this.loading = false
        } else {
          this.unwatchHandle = this.$watch(
            () => this.url,
            (url) => {
              this.renderPDF(url)
            }
          )
        }
      } catch (e) {
        console.warn(e)
      }
    },
  },
  mounted() {
    this.$nextTick(this.init)
  },
  beforeDestroy() {
    this.unwatchHandle && this.unwatchHandle()
  },
}
</script>

<style lang="less" scoped>
.contanier-pdf {
  height: 600px;
}
</style>
